import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ContactUsModal from '../ContactUsModal'

const ContactUsButtonWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1;
`

const StyledContactUsButton = styled.button`
  background-color: ${({ theme }) => theme.primary1};
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.primary2};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export default function ContactUsButton() {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  // 打开聊天窗口的方法
  const openChatWindow = (user_name: string, chat_type: number = 0) => {
    try {
      // 检查 flutter_inappwebview 是否存在
      if (typeof window !== 'undefined' && (window as any).flutter_inappwebview) {
        // @ts-ignore - flutter_inappwebview 可能不存在
        ;(window as any).flutter_inappwebview.callHandler(
          'submit_message',
          JSON.stringify({
            user_name: user_name,
            chat_type: chat_type
          })
        )
        return true // 成功打开聊天窗口
      } else {
        console.error('flutter_inappwebview not available')
        return false // flutter_inappwebview 不存在
      }
    } catch (error) {
      console.error('Failed to open chat window:', error)
      return false // 打开失败
    }
  }

  const handleContactUs = () => {
    // 尝试打开聊天窗口，如果失败则打开弹窗
    const user_name = process.env.REACT_APP_LINKSAY_SERVICE?.toString() || ''
    const chatOpened = openChatWindow(user_name, 0)
    if (!chatOpened) {
      openModal() // 聊天窗口打开失败，使用弹窗
    }
  }

  return (
    <>
      <ContactUsButtonWrapper>
        <StyledContactUsButton onClick={handleContactUs}>{t('contactUs')}</StyledContactUsButton>
      </ContactUsButtonWrapper>
      <ContactUsModal isOpen={isModalOpen} onDismiss={closeModal} />
    </>
  )
}
